package kz.dentalcrm.app.screens.reply_by_template.mvi

import androidx.compose.runtime.Immutable
import kotlinx.collections.immutable.PersistentList
import kotlinx.collections.immutable.persistentListOf
import kz.dentalcrm.app.core.base.ViewState
import kz.dentalcrm.app.data.network.response_model.quick_replies.QuickReply

@Immutable
data class ReplyByTemplateViewState(
    val isLoading: Boolean = false,
    val quickReplies: PersistentList<QuickReply> = persistentListOf(),
    val replyMessageInput: String = "",
    val phone: String = ""
) : ViewState
